<template>
  <section id="projects">
    <section
      class="project"
      :class="alignment(index)"
      v-for="(proj, index) in panda.projects"
      :key="index"
    >
      <div
        class="type"
        :id="proj.url"
      >
        <div
          class="title"
          :class="alignment(index)"
        >
          <h2 class="slide-from-btm-0">
            {{ proj.title }}
          </h2>
        </div>
        <div
          class="descr slide-from-top-1"
          :class="alignment(index)"
        >
          <p>{{ proj.descrShort }}</p>
        </div>
        <div class="view slide-from-top-2"
          :class="alignment(index)"
        >
          <router-link
            class="link"
            :to="'/project/' + proj.url"
          >
            View {{ proj.title }}
          </router-link>
        </div>
        <div class="medium slide-from-top-2"
          :class="alignment(index)"
        >
          <span>{{ proj.medium }}</span>
        </div>
      </div>
      <router-link
        class="cover fade-in-1"
        :to="'/project/' + proj.url"
      >
        <img
          :src="require('@/assets/img/' + proj.imagePrefix + '-cover.jpg')"
          alt="#"
        />
      </router-link>
    </section>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import json from '../json/panda.json'

const panda = ref(json)
const parallaxElements = ref([])

const alignment = (index) => {
  return index % 2 ? 'right' : 'left'
}

const handleScroll = () => {
  const scrollPosition = window.pageYOffset
  parallaxElements.value.forEach((el) => {
    if (el) {
      const rect = el.getBoundingClientRect()
      const speed = parseFloat(el.dataset.speed) || 0.2
      const yOffset = (scrollPosition - rect.top) * speed
      el.style.transform = `${getBaseTransform(el.className)} translateY(${yOffset}px)`
    }
  })
}

const getBaseTransform = (className) => {
  // Extract the base transform from your CSS classes
  if (className.includes('single-wide')) return 'translateZ(0.3px) translateX(10%) translateY(-30%) scale(0.66)'
  if (className.includes('single-square')) return 'translateZ(0.2px) translateX(0%) translateY(-40%) scale(1)'
  // ... add conditions for other window types
  return ''
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true })
  handleScroll() // Initial call to set positions
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss" scoped>
  #projects {
    width: 100%;
    max-width: $breakpoint-max;
    padding-top: 220px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .project {
      width: 85%;
      height: 640px;
      display: flex;
      padding-bottom: 250px;


      .type {
        display: flex;
        flex: 0.8;
        flex-direction: column;

        .title {
          flex: 3;
          display: inline-flex;
          align-items: center;

          h2 {
            font-family: $Medium;
            position: absolute;
            white-space: nowrap;
            z-index: 250;
          }
        }
        .descr {
          flex: 3;
          margin-right: $padding-intrasection;
          
          p {
            font-family: $Light;
          }
        }
        .view {
          flex: 0.75;
          display: flex;
          align-items: center;

          .link {
            font-family: $Light;
            padding-bottom: $padding-link;
            border-bottom: $border-link;
            transition: 0.5s all;
            transform: scale(1);
          }

          .link:hover {
            border-bottom: $white-border-bottom;
            $white-border-bottom: 2px solid $white;
            color: $dark;
            transition: 0.3s all;
          }

          .link:active {
            transform: scale(0.9);
            transition: 0.5s all;
          }

        }
        .medium {
          flex: 0.75;
          display: flex;
          align-items: flex-end;

          span {
            font-family: $Light;
            font-size: 40px;
          }
        }
        .right {
          margin-right: 0;
          margin-left: $padding-intrasection;
        }
        .slide-from-btm-0 {
          animation: $anim-slide-from-btm-0;
        }
        .slide-from-top-1 {
          animation: $anim-slide-from-top-1;
        }
        .slide-from-top-2 {
          animation: $anim-slide-from-top-2;
        }
      }
    
      .cover {
        flex: 2;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: relative;
          z-index: 200;
          transition: 0.5s all;          
        }
      }
      .cover:hover {
        img {
          transition: 0.5s all;
          transform: scale(1.05);
        }
      }
    }
    .left {
      flex-direction: row;
    }
    .right {
      flex-direction: row-reverse;
      text-align: right;
      justify-content: right;
    }
  }
  @media screen and (max-width: $breakpoint-max) {
      #projects {
        .project {
          .type {
            flex: 1;

            .descr {
              margin-right: 20px;

              p {
                font-size: 21px;
                line-height: 32px;
              }
            }
            .right {
              margin-left: 10px;
            }
          }
        }
      }
    }
    @media screen and (max-width: $breakpoint-xl) {
      #projects {
        .project {
          .type {
            .descr {
              margin-right: 10px;
            }
          }
        }
      }
    }
    @media screen and (max-width: $breakpoint-lg) {
      #projects {
        padding-top: 100px;
        justify-content: flex-end;

        .project {
          padding-bottom: 100px;
          height: auto;
          padding-right: 5%;

          .type {
            display: grid;
            grid-template-columns: 50% 50%;
            grid-template-rows: 10% 66vw 15% 10%;
            margin-bottom: 80px;
            flex: 1.2;

            .title {
              grid-column-start: 1;
              grid-column-end: 3;
              grid-row-start: 1;
              grid-row-end: 2;
              align-self: center;

              h2 {
                font-size: 64px;
              }
            }
            .descr {
              grid-column-start: 1;
              grid-column-end: 3;
              grid-row-start: 3;
              grid-row-end: 4;
              align-self: flex-start;
              margin-right: 0;
              margin-left: 0;
              margin-top: 50px;
              margin-bottom: 25px;

              p {
                font-size: 18px;
                line-height: 28px;
              }
            }
            .view, .medium {
              grid-row-start: 4;
              grid-row-end: 5;
              align-items: flex-start;

              span, .link {
                font-size: 21px;
              }
            }
            .view {
              grid-column-start: 2;
              grid-column-end: 3;
              justify-content: flex-end;
            }
            .medium {
              grid-column-start: 1;
              grid-column-end: 2;
              justify-content: flex-start;
              line-height: 26px;
              //align-items: flex-end;
            }
            .medium.right {
              justify-content: flex-end;
              text-align: left;
            }
            .right {
              margin-left: 0;
            }
            .view.right {
              justify-content: flex-start;
            }
          }
          .cover {
            position: absolute;
            z-index: 200;
            left: 0;
            margin-top: 110px;
          }
        }
      }
    }
    @media screen and (max-width: $breakpoint-md) {
      #projects {
        padding-top: 50px;

        .project {
          margin-bottom: 40px;

          .type {
            margin-top: 30px;
            margin-bottom: 0;
            user-select: none;
            grid-template-rows: 10% 66vw 35% 10%;

            .title {
              h2 {
                font-size: 36px;
              }
            }
            .descr {
              user-select: none;

              p {
                font-size: 16px;
                line-height: 28px;
              }
            }
          }
          .cover {
            margin-top: 86px;
          }
        }
      }
    }
    @media screen and (max-width: $breakpoint-xs) {
    }

</style>
